import React from "react";

import { templates } from "@reactivated";

/** @public */
export const Template = (
    _props: templates.DistanceToStoreTemplate,
): React.JSX.Element => {
    return <></>;
};
